var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#00E88F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8914 9.44194C11.6473 9.19786 11.6473 8.80214 11.8914 8.55806C12.1355 8.31398 12.5312 8.31398 12.7753 8.55806L17.7753 13.5581C18.0193 13.8021 18.0193 14.1979 17.7753 14.4419L12.7753 19.4419C12.5312 19.686 12.1355 19.686 11.8914 19.4419C11.6473 19.1979 11.6473 18.8021 11.8914 18.5581L16.4494 14L11.8914 9.44194Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.3ddd2d34852883ae5e42b6e3be110f32.svg";
export { ForwardRef as ReactComponent };